import { componentName, AvatarClass } from './AvatarClass';
import '@vaadin/avatar';
import '@vaadin/icon';
import '@vaadin/icons';

customElements.define(componentName, AvatarClass);

export { AvatarClass, componentName };
